import { POI_TYPE_PRIORITY_BY_BUSINESS, POI_TYPE_PRIORITY_DEFAULT } from "../data/constants";
import { debouncePromise } from "../data/data";
import { SETTINGS } from "../settings";
import { DataSource } from "../stores-js/datasource";
import { SearchParameters } from "../stores-js/searchparameters";
import { DataSearchSource } from "../stores-js/storelocator";
import { generateSearchQuery } from "../utils/global";
import SERVICE_REGISTRY from "./registry";

export class StoreService {
    constructor() {
        const self = this;

        this.selectedStore = null;

        this.selectedStoreForDetail = null;

        // Nearby store search objects initialisation
        const nearbyOptions = {
            maxDistanceFromUser: 1000000,
            storesByPage: 20,
            maxStores: 20,
        };
        this.defaultNearByOptions = nearbyOptions;
        this.dataSource = new DataSource();
        this._storesService = new woosmap.map.StoresService();
        this._debouncedAutocomplete = debouncePromise((request) => this._storesService.autocomplete(request), 300);
        this.dataSearchSource = new DataSearchSource(this.dataSource, null, nearbyOptions);
        this.searchParameters = new SearchParameters({});
        this.searchParameters.maxStores = nearbyOptions.maxStores;
        this.searchParameters.maxDistanceFromUser = nearbyOptions.maxDistanceFromUser;
        this.searchParameters.storesByPage = nearbyOptions.storesByPage;

        this.itinarySearch = false;
        this.itinaryOriginLocation = null;
        this.itinaryDestinationLocation = null;
        this.itinaryDistance = null;
        this.itinaryDuration = null;

        this.dataSearchSource.stores_changed = function () {
            const stores = this.get("stores");

            if (self.itinarySearch) {
                stores.reverse();
                let coordinates = [];
                let storesSubset = [];
                const storesResult = [];
                const data = [];

                // const service = new google.maps.DistanceMatrixService();
                const distanceService = new woosmap.map.DistanceService();

                const requestDistanceMatrix = (origins, destinations, callback) => {
                    const distanceRequest = {
                        origins,
                        destinations,
                        travelMode: woosmap.map.TravelMode.DRIVING,
                        unitSystem: SETTINGS.unitSystem,
                        avoidHighways: SERVICE_REGISTRY.itinaryService.getOptions().avoidHighways,
                        avoidTolls: SERVICE_REGISTRY.itinaryService.getOptions().avoidTolls,
                        avoidFerries: SERVICE_REGISTRY.itinaryService.getOptions().avoidFerries,
                        elements: "duration_distance",
                    };
                    distanceService
                        .getDistanceMatrix(distanceRequest)
                        .then(callback)
                        .catch((error) => {
                            console.error("Error calculating distances:", error);
                            //Fallback when distance matrix throws error, send the stores array without sorting the distance computations.
                            self.itinaryStoreCallback(stores);
                        });
                };

                // const requestDistanceMatrix = function (origins, destinations, callback) {
                //   service.getDistanceMatrix({
                //     origins,
                //     destinations,
                //     travelMode: google.maps.TravelMode.DRIVING,
                //     unitSystem: SETTINGS.unitSystem,
                //     avoidHighways: total.maps.service.itinary.getOptions().avoidHighways,
                //     avoidTolls: total.maps.service.itinary.getOptions().avoidTolls,
                //     avoidFerries: total.maps.service.itinary.getOptions().avoidFerries,
                //   }, callback);
                // };

                const computeDistanceMatrix = (dataArray, callback) => {
                    if (dataArray.length === 0) {
                        // no more store to process
                        callback();
                        return;
                    }

                    const temp = dataArray.pop();
                    const tempCoordinates = temp[0];
                    const tempStoresSubset = temp[1];
                    // Locker
                    let originLocker = {
                        finish: false,
                        response: null,
                        error: false,
                    };
                    let destinationLocker = {
                        finish: false,
                        response: null,
                        error: false,
                    };

                    const processResult = () => {
                        let distance;
                        let duration;
                        if (!originLocker.finish || !destinationLocker.finish) {
                            return;
                        }
                        if (originLocker.error || destinationLocker.error) {
                            // for (idx_ = 0; idx_ < tempStoresSubset.length; idx_++) storesResult.push(tempStoresSubset[idx_]);
                            for (const tempStore of tempStoresSubset) {
                                storesResult.push(tempStore);
                            }
                        } else {
                            // Can't wrap my head around this loop for the moment
                            // eslint-disable-next-line no-plusplus
                            for (let index = destinationLocker.response.rows.length - 1; index >= 0; index--) {
                                distance =
                                    originLocker.response.rows[0].elements[index].status === "OK" &&
                                    destinationLocker.response.rows[index].elements[0].status === "OK"
                                        ? originLocker.response.rows[0].elements[index].distance.value +
                                          destinationLocker.response.rows[index].elements[0].distance.value
                                        : 0;
                                duration =
                                    originLocker.response.rows[0].elements[index].status === "OK" &&
                                    destinationLocker.response.rows[index].elements[0].status === "OK"
                                        ? originLocker.response.rows[0].elements[index].duration.value +
                                          destinationLocker.response.rows[index].elements[0].duration.value
                                        : 0;
                                // if going to a station adds 5 kms or 15min to the trip, then the station is not considered
                                if (distance <= self.itinaryDistance + 5000 || duration <= self.itinaryDuration + 900) {
                                    tempStoresSubset[index].properties.distance =
                                        originLocker.response.rows[0].elements[index].status === "OK"
                                            ? originLocker.response.rows[0].elements[index].distance.value
                                            : 0;
                                    tempStoresSubset[index].properties.duration =
                                        originLocker.response.rows[0].elements[index].status === "OK"
                                            ? originLocker.response.rows[0].elements[index].duration.value
                                            : 0;
                                    storesResult.push(tempStoresSubset[index]);
                                }
                            }

                            originLocker = {
                                finish: false,
                                response: null,
                                error: false,
                            };
                            destinationLocker = {
                                finish: false,
                                response: null,
                                error: false,
                            };
                        }
                        computeDistanceMatrix(dataArray, callback);
                    };

                    const delay = 1000;
                    setTimeout(() => {
                        const callbackDistanceMatrixOrigins = (response, status) => {
                            if (response.status !== "OK") {
                                originLocker.error = true;
                                const cbDelay = 500;
                                setTimeout(() => {
                                    requestDistanceMatrix(
                                        [self.itinaryOriginLocation],
                                        tempCoordinates,
                                        callbackDistanceMatrixOrigins,
                                    );
                                }, cbDelay);
                            } else {
                                originLocker.response = response;
                                originLocker.error = false;
                            }
                            originLocker.finish = true;
                            if (
                                originLocker.finish &&
                                destinationLocker.finish &&
                                !originLocker.error &&
                                !destinationLocker.error
                            )
                                processResult();
                        };

                        const callbackDistanceMatrixDestinations = (response, status) => {
                            if (response.status !== "OK") {
                                destinationLocker.error = true;
                                const cbDelay = originLocker.error ? 750 : 500;
                                setTimeout(() => {
                                    requestDistanceMatrix(
                                        tempCoordinates,
                                        [self.itinaryDestinationLocation],
                                        callbackDistanceMatrixDestinations,
                                    );
                                }, cbDelay);
                            } else {
                                destinationLocker.response = response;
                                destinationLocker.error = false;
                            }
                            destinationLocker.finish = true;
                            if (
                                originLocker.finish &&
                                destinationLocker.finish &&
                                !originLocker.error &&
                                !destinationLocker.error
                            ) {
                                processResult();
                            }
                        };

                        requestDistanceMatrix(
                            [self.itinaryOriginLocation],
                            tempCoordinates,
                            callbackDistanceMatrixOrigins,
                        );
                        requestDistanceMatrix(
                            tempCoordinates,
                            [self.itinaryDestinationLocation],
                            callbackDistanceMatrixDestinations,
                        );
                    }, delay);
                };

                stores.forEach((store, index) => {
                    coordinates.push({
                        lng: store.geometry.coordinates[0],
                        lat: store.geometry.coordinates[1],
                    });

                    storesSubset.push(store);

                    if (index !== 0 && index % 24 === 0) {
                        data.push([coordinates, storesSubset]);
                        coordinates = [];
                        storesSubset = [];
                    }
                });

                if (storesSubset.length > 0) data.push([coordinates, storesSubset]);

                computeDistanceMatrix(data, () => {
                    storesResult.sort((a, b) => {
                        if (a.properties.duration < b.properties.duration) return -1;
                        if (a.properties.duration > b.properties.duration) return 1;
                        return 0;
                    });
                    self.itinaryStoreCallback(storesResult);
                });
            } else {
                const openStores = stores;
                // cherche 5 magasins ouverts maintenant
                /* for (idx in stores) {
                    if (stores[idx].properties && stores[idx].properties.open && (stores[idx].properties.open.open_now || total.maps.utils.open247(stores[idx]))) {
                        openStores.push(stores[idx]);
                        if (openStores.length == 5)
                            break;
                    }
                } */

                if (openStores.length < 5) {
                    // si il reste encore des magasins (nombre de résultats différent du nombre de résultat de la précédente requête
                    if (self.perviousNearStoreSearchResultSize !== stores.length) {
                        self.perviousNearStoreSearchResultSize = stores.length;
                        self.increaseNearStoreSearch();
                        return;
                    }
                }

                self.perviousNearStoreSearchResultSize = -1;
                self.resetNearStoreSearchMaxStoreOption();
                self.searchParameters.maxStores = 20;
                self.searchParameters.storesByPage = 20;

                if (stores) {
                    self.nearbyStoreCallback(openStores);
                } else {
                    self.nearbyStoreCallback([]);
                }
            }
        };
    }
    getStoreByIdOrCode(id, callback) {
        // Airport identifiers (IATA/ICAO) are uppercase; the store id is matched as typed.
        const codeTerm = typeof id === "string" ? id.toUpperCase() : id;
        const clauses = [`idstore:="${id}"`];
        if (SETTINGS.isAviationPortal) {
            // Aviation also searches by airport identifiers. Authoritative keys are
            // code_iata / code_icao; the legacy iata_code is kept as a defensive fallback.
            clauses.push(
                `user.code_iata:="${codeTerm}"`,
                `user.code_icao:="${codeTerm}"`,
                `user.iata_code:="${codeTerm}"`,
            );
        }
        const searchParameters = new SearchParameters({
            query: clauses.join(" or "),
        });
        return this.dataSource.searchStoresByParameters(searchParameters, (data) => {
            const store = data.features.find((currentStore) => {
                if (currentStore.properties.store_id === id) {
                    return true;
                }
                if (!SETTINGS.isAviationPortal) {
                    return false;
                }
                const userProperties = currentStore.properties.user_properties;
                // Compare case-insensitively in case the backend returns non-uppercase codes.
                return (
                    userProperties.code_iata?.toUpperCase() === codeTerm ||
                    userProperties.code_icao?.toUpperCase() === codeTerm ||
                    userProperties.iata_code?.toUpperCase() === codeTerm
                );
            });

            if (store && this._isStoreValid(store)) {
                callback(store);
                return;
            }

            callback(null);
        });
    }
    _isStoreValid(store) {
        if (this.brands) {
            const brand = store.properties.user_properties.brand;
            if (!brand || !this.brands.some((b) => b.toLowerCase() === brand.toLowerCase())) {
                return false;
            }
        }
        if (this.status) {
            const status = store.properties.user_properties.status;
            if (!status || status !== "OPEN") return false;
        }
        return true;
    }
    searchStoresByText(query, callback) {
        const filterQuery = generateSearchQuery();
        const nameClause = `name:"${query}"`;
        const combinedQuery = filterQuery ? `${nameClause} AND ${filterQuery.toString()}` : nameClause;
        const searchParameters = new SearchParameters({
            query: combinedQuery,
            storesByPage: 5,
        });
        return this.dataSource.searchStoresByParameters(searchParameters, (data) => {
            const stores = data.features.filter((store) => this._isStoreValid(store));
            callback(stores);
        });
    }

    autocompleteStoresByText(query, callback) {
        const filterQuery = generateSearchQuery();
        const clauses = [`name:"${query}"`];
        if (filterQuery) clauses.push(filterQuery.toString());
        const request = { query: clauses.join(" AND "), limit: 5 };
        return this._debouncedAutocomplete(request).then((response) => {
            callback(this._dedupAutocompletePredictions(response?.predictions ?? []));
        });
    }

    _dedupAutocompletePredictions(predictions) {
        const selectedBusiness = window.total?.selectedBusiness ?? "all";
        const priorityMap = POI_TYPE_PRIORITY_BY_BUSINESS[selectedBusiness] ?? POI_TYPE_PRIORITY_BY_BUSINESS.all;
        const bestByName = new Map();
        for (const p of predictions) {
            const name = p.name?.toLowerCase();
            if (!name) continue;
            const types = p.types ?? [];
            // StoresService.autocomplete returns types like "STATUS-<BRAND>-<poiType>"
            // (e.g. "OPEN-TOTAL-FUELING"). If the shape ever drifts, poiType
            // becomes undefined and we fall back to POI_TYPE_PRIORITY_DEFAULT.
            const poiType = types[0]?.split("-")[2]?.toUpperCase();
            const priority = priorityMap[poiType] ?? POI_TYPE_PRIORITY_DEFAULT;
            const current = bestByName.get(name);
            if (!current || priority < current.priority) {
                bestByName.set(name, {
                    priority,
                    prediction: { store_id: p.store_id, name: p.name, types },
                });
            }
        }
        return Array.from(bestByName.values()).map((e) => e.prediction);
    }

    init(brands, status) {
        this.status = status;
        this.brands = brands;
    }

    getSelectedStore() {
        return this.selectedStore;
    }

    setSelectedStore(store, centerOnStore, blockCallback) {
        if (store) {
            if (this.selectedStore && this.selectedStore.properties.store_id === store.properties.store_id) return;

            this.selectedStore = store;
            if (!blockCallback) {
                this.selectedStoreCallback(store, centerOnStore);
            }
        } else {
            this.selectedStore = store;
        }
    }

    resetSelectedStore() {
        this.selectedStore = null;
        if (this.selectedStoreResetCallback) this.selectedStoreResetCallback();
    }

    setSelectedStoreForDetail(store) {
        this.storeForDetailCallback(store);
        this.setSelectedStore(store, false, true);
    }

    // When call, search nearby stores and invoke onNearbyStoresChange callback
    setLocation(location) {
        if (location) {
            this.searchParameters.query = generateSearchQuery().toString();
            this.searchParameters.lat = location.lat;
            this.searchParameters.lng = location.lng;
            this.dataSource.searchStoresByParameters(this.searchParameters, (geojson) => {
                this.dataSearchSource.set("stores", geojson.features);
            });
        }
    }

    updateNearbyStores() {
        if (!this.itinarySearch) {
            const location = SERVICE_REGISTRY.locationService.getLocation();
            this.searchParameters.query = generateSearchQuery().toString();
            this.searchParameters.lat = location.lat;
            this.searchParameters.lng = location.lng;
            this.dataSource.searchStoresByParameters(this.searchParameters, (geojson) => {
                this.dataSearchSource.set("stores", geojson.features);
            });
        }
    }

    setUniqueStore(store) {
        this.uniqueStoreCallback(store);
    }

    resetStores() {
        if (this.storeResetCallback) this.storeResetCallback();
    }

    increaseNearStoreSearch() {
        this.searchParameters.storesByPage *= 2;
        this.dataSource.searchStoresByParameters(this.searchParameters, (geojson) => {
            this.dataSearchSource.set("stores", geojson.features);
        });
    }

    resetNearStoreSearchMaxStoreOption() {
        this.dataSearchSource.searchParameters.storesByPage = 20;
        this.dataSearchSource.searchParameters.maxStores = 20;
    }

    setPolylineFilter(encodedPolyline, origin, destination, distance, duration) {
        this.itinarySearch = true;
        this.itinaryOriginLocation = origin;
        this.itinaryDestinationLocation = destination;
        this.itinaryDistance = distance;
        this.itinaryDuration = duration;
        this.searchParameters.query = generateSearchQuery().toString();
        this.searchParameters.maxDistanceFromUser = null;
        this.searchParameters.maxStores = null;
        this.searchParameters.storesByPage = 300;

        let radius;

        if (distance < 100000) {
            radius = 7000;
        } else if (distance < 250000) {
            radius = 5000;
        } else if (distance < 500000) {
            radius = 3000;
        } else if (distance < 750000) {
            radius = 2500;
        } else if (distance < 1000000) {
            radius = 2000;
        } else {
            radius = 1500;
        }
        this.searchParameters.polylineFilter = {
            encodedPolyline,
            radius,
        };
        const searchOptions = {
            storesByPage: 300,
            latLng: {
                lat: origin.lat,
                lng: origin.lng,
            },
            polyline: encodedPolyline,
            radius,
            query: this.searchParameters.query,
        };
        this.searchStoresAlongRoute(searchOptions);

        this.setNearbyOptions({
            maxDistanceFromUser: 1000000,
            storesByPage: 20,
            maxStores: 20,
        });
    }

    resetPolylineFilter() {
        this.itinarySearch = false;
        this.itinaryOriginLocation = null;
        this.itinaryDestinationLocation = null;
        this.itinaryDistance = null;
        this.itinaryDuration = null;

        this.dataSearchSource.searchParameters.storesByPage = 20;
        this.dataSearchSource.searchParameters.maxStores = 20;

        this.dataSearchSource.setPolylineFilter(null);

        const nearbyOptions = {
            maxDistanceFromUser: 1000000,
            storesByPage: 20,
            maxStores: 20,
        };
        this.searchParameters.maxStores = nearbyOptions.maxStores;
        this.searchParameters.maxDistanceFromUser = nearbyOptions.maxDistanceFromUser;
        this.searchParameters.storesByPage = nearbyOptions.storesByPage;
        this.searchParameters.polylineFilter = null;
    }

    setNearbyOptions(nearbyOptions) {
        this.dataSearchSource.setMaxDistanceFromUser(nearbyOptions.maxDistanceFromUser);
        this.dataSearchSource.setMaxStores(nearbyOptions.maxStores);
    }

    resetNearbyOptions() {
        this.dataSearchSource.setMaxDistanceFromUser(null);
        this.dataSearchSource.setMaxStores(null);
    }

    searchStoresAlongRoute(searchParams) {
        const woosStoresSearchService = new woosmap.map.StoresService();
        woosStoresSearchService
            .search(searchParams)
            .then((stores) => this.dataSearchSource.set("stores", stores.features))
            .catch((error) => {
                console.log(error);
            });
    }

    // Events

    onSelectedStoreChange(callback) {
        if (this.selectedStoreCallback) throw new Error("selectedStore callback already registered");
        this.selectedStoreCallback = callback;
    }

    onSelectedStoreReset(callback) {
        if (this.selectedStoreResetCallback) throw new Error("selectedStore reset callback already registered");
        this.selectedStoreResetCallback = callback;
    }

    onNearbyStoresChange(callback) {
        if (this.nearbyStoreCallback) throw new Error("nearbyStore callback already registered");
        this.nearbyStoreCallback = callback;
    }

    onItinaryStoresChange(callback) {
        if (this.itinaryStoreCallback) throw new Error("itinaryStore callback already registered");
        this.itinaryStoreCallback = callback;
    }

    onUniqueStoreChange(callback) {
        if (this.uniqueStoreCallback) throw new Error("uniqueStore callback already registered");
        this.uniqueStoreCallback = callback;
    }

    onStoreForDetailChange(callback) {
        if (this.storeForDetailCallback) throw new Error("onStoreForDetailChange callback already registered");
        this.storeForDetailCallback = callback;
    }

    onStoresReset(callback) {
        if (this.storeResetCallback) throw new Error("store reset callback already registered");
        this.storeResetCallback = callback;
    }
}
